const React = require('react')
const { createPortal } = require('react-dom')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const getZindex = require('lib/zindex')
const log = require('log').create('layer') // eslint-disable-line

class Layer extends React.Component {

    constructor(props) {
        super(props)
        if (typeof document !== 'undefined') {
            this.DisableScroll = require('lib/disablescroll')
            this.layers = document.querySelector('.layers')
            this.container = document.createElement('div')
            this.zindex = getZindex()
        }
    }

    componentDidMount() {
        this.layers.appendChild(this.container)
        this.DisableScroll.on(this.container)
    }

    componentWillUnmount() {
        this.destroyContainer()
    }

    applyPropsToContainer(props) {
        const className = classNames([
            'layer',
            `layer-${this.zindex}`,
            props.className,
        ])
        this.container.className = className

        const { style } = props
        style.zIndex = this.zindex
        Object.keys(style).forEach(key => {
            this.container.style[key] = style[key]
        })
    }

    destroyContainer() {
        if (! this.container) return
        this.DisableScroll.off(this.container)
        this.layers.removeChild(this.container)
        delete this.container
    }

    render() {
        if (! this.container) return null
        this.applyPropsToContainer(this.props)
        return createPortal(
            this.props.children,
            this.container
        )
    }

}

Layer.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object,
}
Layer.defaultProps = {
    style: {},
}

module.exports = Layer
